<template>
  <Observer name="fade-up" class="text-center">
    <strong class="headline h3 -upper" v-if="item && item.headline" v-html="item.headline" data-aos="fade-in"></strong>
    <h2 class="title" v-if="item && item.title" v-html="item.title" data-aos="fade-in"></h2>
    <div v-if="item && item.text" v-html="item.text" class="wysiwyg" data-aos="fade-in"></div>
  </Observer>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
export default {
  props: ['item'],
  name: 'headline_title_text',
  mixins: [ReadyHook]
}
</script>

<style lang="scss" scoped>
  @import "~theme/css/core";

  .-icons .title {
    display: inline;
    color: var(--zenith-white) !important;
    background: var(--zenith-theme-primary) !important;
    box-shadow: -2px 0px 0px 6px var(--zenith-theme-primary);
  }

  .headline {
    display: block;
    margin-bottom: 1rem;
    color: var(--zenith-theme-primary);

    & + .wysiwyg {
      margin-top: 2rem;
    }
  }

  .title {
    margin-bottom: 3rem;
    color: var(--zenith-theme-primary);

    @include bp(max md) {
      margin-bottom: 2rem;
    }
  }

  .wysiwyg {
    /deep/ ul, /deep/ ol {
      padding: 0;
      margin-bottom: 2rem;
      list-style: none;

      li:before {
        content: '-';
        margin-right: 1.4rem;
      }
    }

    /deep/ a {
      color: var(--zenith-theme-primary);
      text-decoration: underline;
    }

    /deep/ p {
      color: var(--zenith-theme-primary);
      margin-bottom: 2rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>
